import { ClientProvider } from "@nju/data-access-sales-client";
import { Footer } from "@nju/feature-portal-footer";
import { CustomerStatusPage } from "@nju/feature-sales-customer-status";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function CustomerStatus() {
  return (
    <LayoutWrapper background="gray">
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <ClientSideOnly>
        <ClientProvider>
          <CustomerStatusPage />
        </ClientProvider>
      </ClientSideOnly>
      <Footer />
    </LayoutWrapper>
  );
}
